export default "<div class=\"container\">\n  <h1 aria-live=\"polite\">\n    Error Page\n  </h1>\n</div>\n"